import React from "react";
import { Card, DataTable, KeyValueList, Table } from "@sscs/ui";
import { capitalize } from "lodash";
import { useParams } from "react-router";
import { FILE_BROWSER_ROUTES, REPORT_PAGES_ROUTES, } from "../../../../constants";
import { cveFiltered } from "../../../../store/vulnerabilitySlice";
import { BugInfo, CweChip, ExpandedRowDetails } from "../../../../ui";
import { CvssDetails, IssuesList, LinkToReportTab, VulnerabilityScore, VulnerabilityTags, } from "../../../common";
import { useReportDispatch } from "../../../hooks";
import { generateFileBrowserTabLink } from "../../../utils";
import { filterByDependencyId } from "../../store/dependenciesSlice";
import { getMostRecentResolution, isTriagedVulnerability } from "../utils";
import styles from "./vulnerability.module.scss";
const LinkToDependency = ({ dependency, }) => {
    const dispatch = useReportDispatch();
    const { fileId = "" } = useParams();
    return (React.createElement(React.Fragment, null,
        React.createElement(LinkToReportTab, { id: `${dependency.uuid}-link`, to: generateFileBrowserTabLink(fileId, FILE_BROWSER_ROUTES.DEPENDENCIES_ROUTE), color: "link", className: styles["impact-link"], onClick: () => {
                dispatch(filterByDependencyId({
                    name: dependency.name,
                    id: dependency.uuid,
                }));
            } }, `${dependency.name} ${dependency.version}`),
        " ",
        React.createElement("small", null, "(Vulnerable dependency)")));
};
const Vulnerability = ({ vulnerability, isFocused, onExpandedRowClick, onExploitClick, }) => {
    const dispatch = useReportDispatch();
    const { fileId = "" } = useParams();
    const hasBugInfo = vulnerability.bugs.length > 0;
    const bugWithMostRecentResolution = getMostRecentResolution(vulnerability);
    const exploitTags = isTriagedVulnerability(vulnerability) &&
        !vulnerability.exploit.includes("TRIAGED")
        ? vulnerability.exploit.concat(["TRIAGED"])
        : vulnerability.exploit;
    return (React.createElement(DataTable.ExpandedRow, { id: vulnerability.cve, focused: isFocused, onClick: onExpandedRowClick },
        React.createElement(DataTable.ExpandedRow.Summary, null,
            React.createElement(Table.Cell, null,
                React.createElement(VulnerabilityScore, { cvss: vulnerability.cvss, exploit: exploitTags })),
            React.createElement(Table.Cell, null,
                React.createElement(LinkToReportTab, { id: `${vulnerability.cve}-link`, to: REPORT_PAGES_ROUTES.VULNERABILITIES_ROUTE, color: "link", className: styles.link, onClick: () => dispatch(cveFiltered(vulnerability.cve)) },
                    React.createElement("div", null, vulnerability.cve),
                    React.createElement("div", { className: styles.name }, vulnerability.name)),
                vulnerability.dependency && (React.createElement(LinkToReportTab, { id: `${vulnerability.dependency.uuid}-link`, to: generateFileBrowserTabLink(fileId, FILE_BROWSER_ROUTES.DEPENDENCIES_ROUTE), className: styles["vulnerable-dependency-summary"], onClick: () => {
                        if (vulnerability.dependency) {
                            dispatch(filterByDependencyId({
                                name: vulnerability.dependency.name,
                                id: vulnerability.dependency.uuid,
                            }));
                        }
                    } }, "Vulnerable dependency"))),
            React.createElement(Table.Cell, null, hasBugInfo && (React.createElement(BugInfo, { bugInfo: bugWithMostRecentResolution.introduced, bugType: "introduced" }))),
            React.createElement(Table.Cell, null, hasBugInfo && (React.createElement(BugInfo, { bugInfo: bugWithMostRecentResolution.resolved, bugType: "resolved" }))),
            React.createElement(Table.Cell, null, isTriagedVulnerability(vulnerability)
                ? vulnerability.outcome
                    .split("-")
                    .map((part) => capitalize(part))
                    .join(" ")
                : "Not triaged"),
            React.createElement(Table.Cell, null,
                React.createElement(VulnerabilityTags, { tags: exploitTags, onClick: (tag) => onExploitClick(tag) }))),
        React.createElement(DataTable.ExpandedRow.Details, null,
            React.createElement(ExpandedRowDetails, null,
                hasBugInfo ? (React.createElement(Card.Card, null,
                    React.createElement(Card.Title, null,
                        React.createElement("div", { className: styles.impact },
                            "Impact",
                            React.createElement("small", null,
                                "Vulnerability data from:",
                                " ",
                                React.createElement("strong", null, vulnerability.sources.join(", "))))),
                    React.createElement(Card.Content, null, React.createElement(KeyValueList, { className: styles["bug-info"], list: {
                            ...(vulnerability.dependency
                                ? {
                                    "Caused by": (React.createElement(LinkToDependency, { dependency: vulnerability.dependency })),
                                }
                                : {}),
                            "Bug description": vulnerability.bugs[0].description,
                            Researchers: vulnerability.bugs[0].researchers.join(", "),
                            CWE: vulnerability.bugs[0].cwe.map((cwe) => (React.createElement(CweChip, { key: cwe.cwe_id, cwe: cwe }))),
                        } })))) : null,
                React.createElement(CvssDetails, { cvss: vulnerability.cvss }),
                React.createElement(IssuesList, { violations: vulnerability.violations, to: REPORT_PAGES_ROUTES.ISSUES_ROUTE })))));
};
export default Vulnerability;
//# sourceMappingURL=Vulnerability.js.map